var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-sm btn-light",class:{'box-loading': _vm.loading},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.stopPropagation();return _vm.parseResume(_vm.candidate._id)}}},[_vm._v("\n  "+_vm._s(_vm.$t('Extract resume data'))+"\n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6616e5a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Candidate/Profile/CandidateProfileResumeParse.vue
// module id = null
// module chunks = 